// DO NOT ADD ANY MORE SVGS TO THIS FILE.
// If you are modifying an existing svg, consider moving it to its own file located next to the component that uses it.

/*eslint-disable max-len, spaced-comment*/
import React from 'react';
import PropTypes from 'prop-types';

import { passThroughProps } from './common/utils/util';

const defaultRadioBoxClassName = 'radio-box-illustration-item';

export const EmptyCustomResolvers = () => (
  <svg width="47px" height="45px" viewBox="0 0 47 45" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Phase-2:-Data-Access" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Custom-Resolvers---Empty-State" transform="translate(-696.000000, -306.000000)">
        <g id="Group-2" transform="translate(331.000000, 306.000000)">
          <g id="Group-6" transform="translate(364.991071, 0.000000)">
            <g
              id="graphql"
              transform="translate(0.008929, 0.000000)"
              fill="#116149"
              fillRule="nonzero"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <g id="A">
                <g id="Group">
                  <polygon
                    id="Path"
                    points="3.61203112 34.2408317 1.97426993 33.2882672 20.2327482 1.47390046 21.8705094 2.42646495"
                  />
                  <polygon
                    id="Path"
                    points="1.60193516 30.7356518 38.1188916 30.7356518 38.1188916 32.6407808 1.60193516 32.6407808"
                  />
                  <path
                    d="M20.5910084,42.4148648 L2.32485319,31.805356 L3.27168387,30.1576769 L21.5365596,40.7646112 L20.5910084,42.4148648 Z M36.4568199,14.7608879 L18.1945032,4.15266628 L19.1413339,2.50498716 L37.4074891,13.114496 L36.4568199,14.7608879 Z"
                    id="Shape"
                  />
                  <polygon
                    id="Path"
                    points="3.27552238 14.7557389 2.32869169 13.1080597 20.6089214 2.51013616 21.5557521 4.15781528"
                  />
                  <path
                    d="M36.1203112,34.2408317 L17.861833,2.41359246 L19.4995941,1.46102797 L37.7580724,33.2753947 L36.1203112,34.2408317 Z M3.05033021,11.8426937 L4.93887358,11.8426937 L4.93887358,33.0629986 L3.05033021,33.0629986 L3.05033021,11.8426937 Z M34.7909097,11.8426937 L36.6845711,11.8426937 L36.6845711,33.0629986 L34.8024252,33.0629986 L34.7909097,11.8426937 Z"
                    id="Shape"
                  />
                  <polygon
                    id="Path"
                    points="20.2672947 41.6090468 19.4407371 40.1673275 35.3142256 30.9403245 36.1407832 32.3820437"
                  />
                  <path
                    d="M39.1911134,33.6834528 C38.0907426,35.5975925 35.6571319,36.2553769 33.7532345,35.150917 C31.8493371,34.0464571 31.1967916,31.5955344 32.2946034,29.6801074 C33.3924152,27.7646804 35.828585,27.1081833 37.7324824,28.2126432 C38.6498845,28.7404154 39.3190635,29.6286174 39.5928767,30.6429699 C39.8666899,31.6573223 39.7233858,32.7643567 39.1923929,33.68474 M7.43006189,15.2281594 C6.32969109,17.1422991 3.89608033,17.8000835 1.99218295,16.6956236 C0.088285564,15.5911637 -0.562980408,13.1428155 0.532272386,11.224814 C1.62752518,9.30681253 4.06625395,8.65288988 5.97015133,9.75734979 C7.87062719,10.8664309 8.52309054,13.3120209 7.43006189,15.2294466 M0.546346896,33.6834528 C-0.547626397,31.7680258 0.101080573,29.3248266 2.00497795,28.2126432 C3.90887534,27.112045 6.3373681,27.7646804 7.4428569,29.6801074 C8.53683019,31.5955344 7.88812322,34.0387336 5.98422584,35.150917 C4.06497445,36.2515151 1.63776119,35.6014542 0.546346896,33.6834528 M32.3099574,15.2281594 C31.2159841,13.3127324 31.8646911,10.8695332 33.7685885,9.75734979 C35.6724859,8.65546438 38.1009786,9.30938703 39.2064674,11.224814 C40.3004407,13.140241 39.6517338,15.5834402 37.7478364,16.6956236 C35.84138,17.7987962 33.4103282,17.1422991 32.3099574,15.2281594 M19.8668109,44.914703 C17.6660693,44.914703 15.887563,43.112554 15.887563,40.9113576 C15.8882692,38.7013763 17.6688527,36.91001 19.8655314,36.9092995 C22.0622101,36.91001 23.8427936,38.7013763 23.8434998,40.9113576 C23.8396613,43.1202775 22.061155,44.9108413 19.8642519,44.914703 M19.8642519,8.00282898 C17.6635103,8.00282898 15.885004,6.20067994 15.885004,3.99948361 C15.887123,1.78899968 17.6696321,-0.00142256173 19.8668109,-8.47124253e-07 C22.0634896,0.000710490748 23.8440731,1.79207681 23.8447822,4.00205811 C23.8460588,5.06403879 23.427662,6.08354025 22.6804335,6.8340066 C21.9332049,7.58447295 20.9211197,8.00540347 19.8655314,8.00540347"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="Group-5" transform="translate(23.008929, 19.000000)">
              <rect id="Rectangle" fill="#FFFFFF" x="1.625" y="4.875" width="21.9375" height="17.875" />
              <g id="fontawesome-free-5.5.0/Regular/edit" fill="#16CC62">
                <g id="edit" transform="translate(3.250000, 4.333333)">
                  <path
                    d="M14.2781981,12.3604856 L15.4139236,11.2139227 C15.5913807,11.0347722 15.900156,11.1601775 15.900156,11.4181542 L15.900156,16.6278494 C15.900156,17.5773468 15.1370905,18.3476937 14.1965679,18.3476937 L1.70358814,18.3476937 C0.763065523,18.3476937 0,17.5773468 0,16.6278494 L0,4.01565743 C0,3.06616002 0.763065523,2.29581307 1.70358814,2.29581307 L11.4104914,2.29581307 C11.6624805,2.29581307 11.7902496,2.60395185 11.6127925,2.78668531 L10.4770671,3.93324822 C10.42383,3.98699335 10.3528471,4.01565743 10.274766,4.01565743 L1.70358814,4.01565743 L1.70358814,16.6278494 L14.1965679,16.6278494 L14.1965679,12.5611341 C14.1965679,12.4858909 14.224961,12.4142307 14.2781981,12.3604856 Z M19.8361544,5.12997325 L10.5161076,14.5389551 L7.30768331,14.897256 C6.37780811,15.0011633 5.58634945,14.2093183 5.68927457,13.2634039 L6.04418877,10.0243637 L15.3642356,0.615381809 C16.1769891,-0.20512727 17.4901716,-0.20512727 18.299376,0.615381809 L19.8326053,2.16324173 C20.6453588,2.98375081 20.6453588,4.31304718 19.8361544,5.12997325 L19.8361544,5.12997325 Z M16.3296022,6.23712305 L14.2675507,4.15539478 L7.67324493,10.8162087 L7.41415757,13.1559136 L9.73174727,12.8943539 L16.3296022,6.23712305 Z M18.6294462,3.38146482 L17.0962168,1.8336049 C16.950702,1.68670152 16.7129095,1.68670152 16.5709438,1.8336049 L15.474259,2.9407547 L17.5363105,5.02248298 L18.6329953,3.91533317 C18.774961,3.76484679 18.774961,3.52836819 18.6294462,3.38146482 L18.6294462,3.38146482 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EmptyFilters = () => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" className="empty-state-svg">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.900000036"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Stitch-Rules-HiFi-41" transform="translate(-825.000000, -441.000000)" strokeWidth="2">
        <g id="Charts:-Create-New-Chart" transform="translate(475.000000, 442.000000)">
          <g id="Group-46" transform="translate(351.000000, 0.000000)">
            <g id="Group-1034" transform="translate(26.000000, 22.000000)" stroke="#15CC62">
              <path
                d="M19.5,4 C19.5,5.934 15.246,7.5 10,7.5 C4.753,7.5 0.5,5.934 0.5,4 C0.5,2.066 4.753,0.5 10,0.5 C15.246,0.5 19.5,2.066 19.5,4 L19.5,4 Z"
                id="Stroke-2203"
              />
              <path d="M0.5,4 L0.5,6.5 C0.5,7.6 1.137,9.137 1.915,9.914 L8.5,16.5" id="Stroke-2204" />
              <path d="M19.5,4 L19.5,6.5 C19.5,7.6 18.864,9.137 18.086,9.914 L11.5,16.5" id="Stroke-2205" />
              <path
                d="M11.5,16.5 L11.5,22.5 C11.5,23.05 11.051,23.5 10.5,23.5 L9.5,23.5 C8.95,23.5 8.5,23.05 8.5,22.5 L8.5,16.5"
                id="Stroke-2206"
              />
            </g>
            <path d="M6,12 L15,12" id="Stroke-872" stroke="#116149" />
            <path d="M6,18 L22,18" id="Stroke-873" stroke="#116149" />
            <path d="M6,24 L18,24" id="Stroke-874" stroke="#116149" />
            <path d="M6,30 L16,30" id="Stroke-875" stroke="#116149" />
            <polyline id="Stroke-876" stroke="#116149" points="29 42 0 42 0 0 22 0 32 10 32 18" />
            <polyline id="Stroke-877" stroke="#116149" points="22 0 22 10 32 10" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Desktop = () => (
  <svg width="68px" height="61px" viewBox="0 0 68 61" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="FY2020Q4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="MongoDB-Realm-Applications-Empty-State-(MDB-World-Version)"
        transform="translate(-799.000000, -494.000000)"
        strokeWidth="1.2"
      >
        <g id="fontawesome-free-5.5.0/Solid/desktop" transform="translate(799.000000, 494.000000)">
          <g id="desktop">
            <path
              d="M66.6,5.64923077 L66.6,43.3107692 C66.6,44.7051717 66.0396132,45.9682257 65.1332583,46.8825486 C64.2287962,47.794962 62.9796123,48.36 61.6,48.36 L38.3698364,48.36 L40.6330172,55.2092308 L49.4666667,55.2092308 C50.0756494,55.2092308 50.6251857,55.4562199 51.0224249,55.8569514 C51.4215523,56.2595875 51.6666667,56.8168334 51.6666667,57.4338462 C51.6666667,58.0508589 51.4215523,58.6081048 51.0224249,59.0107409 C50.6251857,59.4114724 50.0756494,59.6584615 49.4666667,59.6584615 L17.7333333,59.6584615 C17.1243506,59.6584615 16.5748143,59.4114724 16.1775751,59.0107409 C15.7784477,58.6081048 15.5333333,58.0508589 15.5333333,57.4338462 C15.5333333,56.8168334 15.7784477,56.2595875 16.1775751,55.8569514 C16.5748143,55.4562199 17.1243506,55.2092308 17.7333333,55.2092308 L26.5669828,55.2092308 L28.8301636,48.36 L5.6,48.36 C4.22038773,48.36 2.97120379,47.794962 2.06674172,46.8825486 C1.16038677,45.9682257 0.6,44.7051717 0.6,43.3107692 L0.6,5.64923077 C0.6,4.2548283 1.16038677,2.99177427 2.06674172,2.07745137 C2.97120379,1.16503799 4.22038773,0.6 5.6,0.6 L61.6,0.6 C62.9796123,0.6 64.2287962,1.16503799 65.1332583,2.07745137 C66.0396132,2.99177427 66.6,4.2548283 66.6,5.64923077 Z"
              id="Path"
              stroke="#116149"
            />
            <path
              d="M8.06666667,8.13230769 L59.1333333,8.13230769 L59.1333333,40.8276923 L8.06666667,40.8276923 L8.06666667,8.13230769 Z"
              id="Path"
              stroke="#16CC62"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const MobileAlt = () => (
  <svg width="38px" height="61px" viewBox="0 0 38 61" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="FY2020Q4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="MongoDB-Realm-Applications-Empty-State-(MDB-World-Version)"
        transform="translate(-665.000000, -494.000000)"
        strokeWidth="1.2"
      >
        <g id="fontawesome-free-5.5.0/Solid/mobile-alt" transform="translate(665.000000, 494.000000)">
          <g id="mobile-alt">
            <path
              d="M37.082243,5.7151751 L37.082243,55.2466926 C37.082243,56.6594589 36.5158804,57.9392039 35.5996822,58.8655877 C34.6858722,59.7895567 33.4238104,60.3618677 32.0299065,60.3618677 L5.65233645,60.3618677 C4.25843257,60.3618677 2.99637077,59.7895567 2.08256079,58.8655877 C1.16636261,57.9392039 0.6,56.6594589 0.6,55.2466926 L0.6,5.7151751 C0.6,4.30240884 1.16636261,3.02266385 2.08256079,2.09628003 C2.99637077,1.17231097 4.25843257,0.6 5.65233645,0.6 L32.0299065,0.6 C33.4238104,0.6 34.6858722,1.17231097 35.5996822,2.09628003 C36.5158804,3.02266385 37.082243,4.30240884 37.082243,5.7151751 Z"
              id="Path"
              stroke="#116149"
            />
            <path
              d="M18.8411215,56.551751 C17.9656638,56.551751 17.1744535,56.1938994 16.602,55.6150818 C16.0271614,55.0338526 15.6728972,54.2301998 15.6728972,53.3416342 C15.6728972,52.4530687 16.0271614,51.6494159 16.602,51.0681866 C17.1744535,50.489369 17.9656638,50.1315175 18.8411215,50.1315175 C19.7165792,50.1315175 20.5077895,50.489369 21.0802429,51.0681866 C21.6550816,51.6494159 22.0093458,52.4530687 22.0093458,53.3416342 C22.0093458,54.2301998 21.6550816,55.0338526 21.0802429,55.6150818 C20.5077895,56.1938994 19.7165792,56.551751 18.8411215,56.551751 Z"
              id="Path"
              stroke="#16CC62"
            />
            <path
              d="M31.4299065,44.292607 C31.4299065,44.5212844 31.3372439,44.7290898 31.1882102,44.8797803 C31.0415709,45.0280499 30.8396748,45.1214008 30.6168224,45.1214008 L7.06542056,45.1214008 C6.84256821,45.1214008 6.6406721,45.0280499 6.49403275,44.8797803 C6.34499912,44.7290898 6.25233645,44.5212844 6.25233645,44.292607 L6.25233645,7.14396887 C6.25233645,6.9152915 6.34499912,6.70748608 6.49403275,6.55679559 C6.6406721,6.40852601 6.84256821,6.3151751 7.06542056,6.3151751 L30.6168224,6.3151751 C30.8396748,6.3151751 31.0415709,6.40852601 31.1882102,6.55679559 C31.3372439,6.70748608 31.4299065,6.9152915 31.4299065,7.14396887 L31.4299065,44.292607 Z"
              id="Path"
              stroke="#16CC62"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Laptop = () => (
  <svg width="75px" height="61px" viewBox="0 0 75 61" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="FY2020Q4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="MongoDB-Realm-Applications-Empty-State-(MDB-World-Version)"
        transform="translate(-493.000000, -494.000000)"
        strokeWidth="1.2"
      >
        <g id="fontawesome-free-5.5.0/Solid/laptop" transform="translate(493.000000, 494.000000)">
          <g id="laptop">
            <path
              d="M74.0666667,50.8430769 L74.0666667,52.7261538 C74.0666667,54.6331383 73.2930903,56.3666165 72.0472166,57.6234429 C70.8032407,58.8783549 69.0877418,59.6584615 67.2,59.6584615 L7.46666667,59.6584615 C5.57892487,59.6584615 3.863426,58.8783549 2.61945006,57.6234429 C1.37357641,56.3666165 0.6,54.6331383 0.6,52.7261538 L0.6,50.8430769 C0.6,50.4896309 0.743576407,50.1684604 0.974450057,49.9355571 C1.203426,49.7045682 1.51892487,49.56 1.86666667,49.56 L29.2237753,49.56 C29.3684767,50.4293775 29.8388951,51.3249218 30.5485435,52.0239876 C31.3350346,52.7987502 32.4035035,53.3261538 33.6,53.3261538 L40.6933333,53.3261538 C41.9357161,53.3261538 43.0302873,52.885336 43.8212716,52.1054332 C44.4631689,51.4725288 44.9109756,50.6115718 45.0612609,49.56 L72.8,49.56 C73.1477418,49.56 73.4632407,49.7045682 73.6922166,49.9355571 C73.9230903,50.1684604 74.0666667,50.4896309 74.0666667,50.8430769 Z"
              id="Path"
              stroke="#116149"
            />
            <path
              d="M13.0666667,0.6 L61.6,0.6 C62.9744085,0.6 64.2232407,1.16826052 65.1288833,2.08186483 C66.0364236,2.99738352 66.6,4.26009243 66.6,5.64923077 L66.6,44.5938462 L8.06666667,44.5938462 L8.06666667,5.64923077 C8.06666667,4.26009243 8.63024307,2.99738352 9.53778339,2.08186483 C10.443426,1.16826052 11.6922582,0.6 13.0666667,0.6 Z"
              id="Path"
              stroke="#116149"
            />
            <path
              d="M59.1333333,37.0615385 L15.5333333,37.0615385 L15.5333333,8.13230769 L59.1333333,8.13230769 L59.1333333,37.0615385 Z"
              id="Path"
              stroke="#16CC62"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const GoogleLogin = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48">
    <g>
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
      <path fill="none" d="M0 0h48v48H0z" />
    </g>
  </svg>
);

export const Export = () => (
  <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="import-export-1" transform="translate(-1199.000000, -410.000000)" fill="#474C4F">
        <g id="Group-2" transform="translate(1199.000000, 410.000000)">
          <path
            d="M11.2008,14.4 L1.6,14.4 L1.6,1.6 L8,1.6 L8,4.8 L11.2,4.8 L11.2008,14.4 Z M12.8,6.90676697 L11.2021118,6.90676697 L11.2021118,9.92886102 L12.8,9.92886102 L12.8,14.4 C12.8,15.2832 12.0832,16 11.2,16 L1.6,16 C0.7176,16 0,15.2832 0,14.4 L0,1.6 C0,0.7184 0.7176,0 1.6,0 L9.1312,0 L12.8,3.6688 L12.8,6.90676697 Z"
            id="Combined-Shape"
          />
          <polygon
            id="Combined-Shape"
            points="14.3572859 6 14.3572859 7.59042222 7 7.59042222 7 9.01251627 14.3572859 9.01251627 14.3572859 10.7435518 16.543981 8.37177596"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const PushNotifications = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 16 16"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-8" transform="translate(-1.000000, 0.000000)">
        <path
          d="M14.3333333,11.7239333 L12.6093333,9.99993333 L13.6666667,8.9426 L15.3906667,10.6666 L14.3333333,11.7239333 Z M8.57533333,8.42326667 C8.39466667,8.2426 8.19333333,8.0926 7.982,7.95993333 L11.6666667,4.27593333 L12.724,5.33326667 L9.03933333,9.0166 C8.908,8.80726667 8.758,8.60526667 8.57533333,8.42326667 Z M8.02333333,11.6432667 L5.356,8.97526667 C6.08866667,8.62526667 7.04,8.77393333 7.63266667,9.36593333 C8.24733333,9.98193333 8.37733333,10.8999333 8.02333333,11.6432667 Z M5.276,2.6666 L6.33333333,1.60926667 L8.05733333,3.33326667 L7,4.3906 L5.276,2.6666 Z M16.8046667,10.1952667 L14.138,7.5286 C13.8773333,7.26793333 13.456,7.26793333 13.1953333,7.5286 L12.6666667,8.05726667 L12.276,7.6666 L13.6666667,6.27593333 C14.186,5.7566 14.186,4.90993333 13.6666667,4.3906 L13.6093333,4.33326667 L14.8046667,3.13793333 L13.862,2.19526667 L12.6666667,3.3906 L12.6093333,3.33326667 C12.09,2.8126 11.2433333,2.8126 10.724,3.33326667 L9.33333333,4.72393333 L8.94266667,4.33326667 L9.47133333,3.8046 C9.732,3.54393333 9.732,3.1226 9.47133333,2.86193333 L6.80466667,0.195266667 C6.544,-0.0654 6.12266667,-0.0654 5.862,0.195266667 L3.862,2.19526667 C3.60133333,2.45593333 3.60133333,2.87726667 3.862,3.13793333 L6.52866667,5.8046 C6.65866667,5.9346 6.82933333,5.99993333 7,5.99993333 C7.17066667,5.99993333 7.34133333,5.9346 7.47133333,5.8046 L8,5.27593333 L8.39066667,5.6666 L6.574,7.4826 C6.45533333,7.46993333 6.33933333,7.44793333 6.21866667,7.44793333 C5.328,7.44793333 4.49066667,7.7946 3.862,8.42326667 C3.60133333,8.68326667 3.60133333,9.10526667 3.862,9.36593333 L7.63266667,13.1379333 C7.758,13.2632667 7.92733333,13.3332667 8.104,13.3332667 C8.28066667,13.3332667 8.45066667,13.2632667 8.57533333,13.1379333 C9.31533333,12.3986 9.61866667,11.3946 9.51533333,10.4259333 L11.3333333,8.60926667 L11.724,8.99993333 L11.1953333,9.5286 C10.9346667,9.78926667 10.9346667,10.2106 11.1953333,10.4712667 L13.862,13.1379333 C13.992,13.2679333 14.1626667,13.3332667 14.3333333,13.3332667 C14.504,13.3332667 14.6746667,13.2679333 14.8046667,13.1379333 L16.8046667,11.1379333 C17.0653333,10.8772667 17.0653333,10.4559333 16.8046667,10.1952667 Z M2.33266667,10.6666667 L0.999333333,10.6666667 C1,12.0913333 1.55466667,13.43 2.562,14.4373333 C3.56933333,15.4446667 4.90866667,16 6.33333333,16 L6.33333333,14.6666667 C5.26466667,14.6666667 4.26066667,14.25 3.50466667,13.4946667 C2.74933333,12.7393333 2.33333333,11.7346667 2.33266667,10.6666667 Z M4.33333333,10.6666667 L3,10.6666667 C3,11.556 3.34666667,12.3933333 3.97666667,13.0233333 C4.604,13.6526667 5.44133333,13.9986667 6.33333333,13.9986667 L6.33333333,12.6653333 C5.798,12.6653333 5.29533333,12.4573333 4.91933333,12.0806667 C4.542,11.7033333 4.33333333,11.2006667 4.33333333,10.6666667 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </svg>
);

export const Code = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 45 40"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard" fill="none">
        <path
          d="M26.8833573,5.39017715 L25.5944512,5.03200132 C25.4285542,4.97592727 25.2651324,4.99356341 25.1062167,5.08476213 C24.9467987,5.17604203 24.839132,5.31306519 24.7838063,5.49562498 L17.0315952,32.6934536 C16.9762695,32.876082 16.9935952,33.0483051 17.0836377,33.2096085 C17.1736876,33.3712072 17.3085803,33.4800472 17.4889638,33.5361249 L18.7775059,33.8944447 C18.9437669,33.9509666 19.1066063,33.9332582 19.2659588,33.8419067 C19.4253768,33.7501855 19.5328251,33.6136029 19.588078,33.4313434 L27.3405075,6.23307358 C27.3957603,6.05052117 27.3785803,5.87829216 27.2883849,5.71662269 C27.1982695,5.55502702 27.0635224,5.44618478 26.8833573,5.39017715 Z"
          id="Fill-1"
        />
        <path
          d="M15.0961061,10.7488107 C15.0961061,10.5662509 15.0267307,10.4045814 14.8881981,10.2642303 L13.8489054,9.21082188 C13.7103801,9.07039695 13.5509621,9 13.3708625,9 C13.1907701,9 13.0312793,9.07047074 12.8928195,9.21082188 L3.20790215,19.0280377 C3.06915512,19.1684552 3,19.3300583 3,19.5126107 C3,19.6951631 3.06937351,19.8567588 3.20790215,19.9971099 L12.8927467,29.8143257 C13.0312065,29.954972 13.1904061,30.0249188 13.3707897,30.0249188 C13.5511805,30.0249188 13.7103801,29.9547506 13.8488398,29.8143257 L14.8881253,28.7615003 C15.0266579,28.6211565 15.0960333,28.4594796 15.0960333,28.2767059 C15.0960333,28.0943748 15.0266579,27.9327718 14.8881253,27.792428 L6.72032667,19.5126107 L14.8881981,11.2333837 C15.026949,11.0930326 15.0961061,10.9313631 15.0961061,10.7488107 Z"
          id="Fill-3"
        />
        <path
          d="M40.8875502,19.0280377 L31.202413,9.21082188 C31.0639533,9.07047074 30.9044625,9 30.7246613,9 C30.5442705,9 30.3853621,9.07047074 30.2463927,9.21082188 L29.2075441,10.2641565 C29.0690843,10.4045814 29,10.5659557 29,10.7487369 C29,10.9315107 29.0690115,11.0929588 29.2075441,11.2333099 L37.375564,19.5127583 L29.2075441,27.7926494 C29.0690843,27.9329931 29,28.0946626 29,28.2769272 C29,28.4597748 29.0690115,28.6213705 29.2075441,28.7617216 L30.2463927,29.8145471 C30.3853621,29.955186 30.5443433,30.0251402 30.7246613,30.0251402 C30.9045352,30.0251402 31.0639533,29.9549646 31.202413,29.8145471 L40.8875502,19.9974051 C41.0260828,19.8570539 41.0953054,19.6951631 41.0953054,19.5126107 C41.0953054,19.3299845 41.0260828,19.1683814 40.8875502,19.0280377 Z"
          id="Fill-4"
        />
      </g>
    </g>
  </svg>
);

export const Twilio = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 45 40"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard-Copy" fill="none">
        <path
          d="M22,3 C12.616,3 5,10.616 5,20 C5,29.384 12.616,37 22,37 C31.384,37 39,29.384 39,20 C39,10.616 31.384,3 22,3 Z M22,32.512 C15.081,32.512 9.488,26.902 9.488,20 C9.488,13.081 15.098,7.488 22,7.488 C28.919,7.488 34.512,13.098 34.512,20 C34.512,26.919 28.919,32.512 22,32.512 Z"
          id="XMLID_181_"
        />
        <ellipse id="XMLID_180_" cx="26.233" cy="15.767" rx="3.536" ry="3.536" />
        <circle id="XMLID_179_" cx="26.233" cy="24.233" r="3.536" />
        <ellipse id="XMLID_178_" cx="17.767" cy="24.233" rx="3.536" ry="3.536" />
        <circle id="XMLID_177_" cx="17.767" cy="15.767" r="3.536" />
      </g>
    </g>
  </svg>
);

export const Github = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 45 40"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard-Copy-2" fill="none">
        <path
          d="M37.719561,11.4667729 C36.1993743,8.86211415 34.1373354,6.79999767 31.5329092,5.27996604 C28.9280955,3.75985688 26.0844061,3 22.9998411,3 C19.9156636,3 17.0710517,3.76008947 14.4667806,5.27996604 C11.8621157,6.79992014 9.80015661,8.86211415 8.27996992,11.4667729 C6.76001605,14.0713618 6,16.9155861 6,19.9993759 C6,23.7037102 7.08075296,27.0347409 9.24280237,29.9933201 C11.4046184,32.9521334 14.1973663,34.999517 17.620812,36.1357028 C18.0193048,36.2096662 18.3143038,36.1576427 18.5061112,35.9809549 C18.6979963,35.8040331 18.7938225,35.5824551 18.7938225,35.3171514 C18.7938225,35.2728814 18.7900235,34.8746157 18.7826582,34.1218885 C18.7750604,33.3691596 18.771494,32.7124919 18.771494,32.1521885 L18.2623591,32.2402602 C17.9377517,32.2997252 17.528242,32.324923 17.0338377,32.3177895 C16.5396737,32.3108902 16.0266623,32.2591006 15.4955091,32.1628092 C14.9641311,32.0673722 14.4698818,31.846026 14.0123814,31.4992398 C13.5551175,31.1524536 13.2305039,30.6985211 13.0386197,30.1381425 L12.8172743,29.6287773 C12.6697368,29.2896657 12.4374606,28.9129524 12.1201347,28.5000368 C11.8028089,28.0867281 11.4819167,27.8065373 11.1573031,27.658999 L11.0023228,27.5480546 C10.8990545,27.4743242 10.8032283,27.3854059 10.7146131,27.2822144 C10.6260754,27.1790229 10.5597879,27.0757539 10.5155187,26.9723298 C10.4711727,26.8688282 10.5079208,26.7839336 10.626153,26.7173359 C10.7443844,26.6507383 10.9580543,26.6184086 11.2680924,26.6184086 L11.7106273,26.684541 C12.0057798,26.7436959 12.3708637,26.9203852 12.8063434,27.2156943 C13.2415906,27.510763 13.5993875,27.894378 13.8798063,28.3663763 C14.2193846,28.9715677 14.6285067,29.4327096 15.1083356,29.7500339 C15.587769,30.067359 16.0711641,30.2257506 16.5580481,30.2257506 C17.0449244,30.2257506 17.4654433,30.1888459 17.8197521,30.1154264 C18.1736734,30.0416193 18.5057314,29.9306756 18.8157633,29.7832149 C18.9485709,28.7940977 19.3101676,28.0342408 19.9002431,27.5030876 C19.0592052,27.4147042 18.3030698,27.2815864 17.6314335,27.104587 C16.9601848,26.927355 16.266538,26.6397291 15.5509426,26.2409184 C14.8349673,25.8426504 14.2410153,25.348091 13.7689472,24.7581008 C13.2967922,24.1677928 12.9093031,23.3928177 12.6070172,22.4338578 C12.3045769,21.4745181 12.1533188,20.3678649 12.1533188,19.1136037 C12.1533188,17.3277241 12.736336,15.8080026 13.9021348,14.5535863 C13.3560246,13.2109417 13.4075816,11.7057957 14.0569608,10.0383033 C14.4849225,9.90534061 15.1195773,10.0051208 15.9606074,10.337016 C16.8018002,10.669074 17.4176852,10.9535289 17.808898,11.1893731 C18.2001109,11.4251396 18.5135618,11.6249326 18.7497083,11.7869689 C20.1223567,11.4034314 21.5388945,11.211624 22.9996938,11.211624 C24.460493,11.211624 25.8773331,11.4034314 27.2500591,11.7869689 L28.0911745,11.2559707 C28.6663565,10.9016618 29.3455907,10.5769691 30.1272333,10.2818151 C30.9093489,9.9868239 31.5074021,9.90557319 31.9207883,10.0385359 C32.5845942,11.7061058 32.643749,13.2111743 32.0974776,14.5538189 C33.2632003,15.8082352 33.8464532,17.3283443 33.8464532,19.1138363 C33.8464532,20.3680975 33.6946509,21.4782317 33.3926743,22.4449445 C33.09031,23.4118046 32.6994848,24.1860122 32.2200514,24.7691798 C31.7400675,25.3522776 31.1423167,25.8429605 30.426729,26.2411432 C29.7109785,26.6396438 29.0170991,26.9272775 28.3458504,27.1045095 C27.6742994,27.2817415 26.9181562,27.414929 26.0771261,27.5034675 C26.8441932,28.1672733 27.2278082,29.2150756 27.2278082,30.6464152 L27.2278082,35.3165242 C27.2278082,35.5818279 27.3200681,35.8033276 27.5047429,35.9803279 C27.6891773,36.1570157 27.9804549,36.2090392 28.3789554,36.1349977 C31.8028663,34.998965 34.5956111,32.9515046 36.7573527,29.9926905 C38.918854,27.0341051 40,23.7030822 40,19.9987479 C39.9992247,16.9153535 39.2388174,14.0713618 37.719561,11.4667729 Z"
          id="Page-1-Copy"
        />
      </g>
    </g>
  </svg>
);

export const AWS = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 45 40"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard-Copy-3" fill="none">
        <polygon id="Fill-3" points="21.6923077 37 6 31.7692308 6 10.8461538 21.6923077 16.0769231" />
        <polygon id="Fill-4" points="40 31.7692308 24.3076923 37 24.3076923 16.0769231 40 10.8461538" />
        <polygon id="Fill-5" points="38.6923077 8.23076923 23 3 7.30769231 8.23076923 23 13.4615385" />
      </g>
    </g>
  </svg>
);

export const MongoDB = (props) => (
  <svg
    width="45px"
    height="40px"
    viewBox="0 0 45 40"
    version="1.1"
    className={props.className ? props.className : defaultRadioBoxClassName}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard-Copy-4" fill="none">
        <g id="Page-1" transform="translate(14.000000, 4.000000)">
          <path
            d="M9,4.73 C11,6.31 14,9.73 14,16 C14,19.59 12,22 9,22 C6,22 4,19.59 4,16 C4,9.74 7,6.3 9,4.73 L9,4.73 Z M9,0 C9,0 0,4 0,16 C0,22.08 4,26 9,26 C14,26 18,22 18,16 C18,4 9,0 9,0 Z"
            id="Fill-3"
          />
          <polygon id="Stroke-4" points="10 31.89 10 2 8 2 8 31.89" />
        </g>
      </g>
    </g>
  </svg>
);

export const EmptyClusters = () => (
  <svg width="60px" height="60px" viewBox="0 0 45 45" version="1.1" className="empty-state-svg">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Empty-State" transform="translate(-676.000000, -241.000000)">
        <g id="Group-1370" transform="translate(676.000000, 241.000000)">
          <g transform="translate(0.000000, 1.000000)">
            <g id="Group-40" transform="translate(22.000000, 21.000000)" stroke="#16CC62" strokeWidth="2">
              <g>
                <path
                  d="M11.4332778,16.6175778 L7.54294444,20.5066889 C6.11172222,21.9391333 3.7895,21.9391333 2.35705556,20.5066889 L1.49294444,19.6425778 C0.0617222222,18.2113556 0.0617222222,15.8891333 1.49294444,14.4579111 L7.1115,8.83935556 C8.54394444,7.40691111 10.8649444,7.40691111 12.2973889,8.83935556 L13.1615,9.70468889"
                  id="Stroke-80"
                />
                <path
                  d="M10.5691667,5.3812 L14.4582778,1.49331111 C15.8907222,0.0608666667 18.2105,0.0608666667 19.6429444,1.49331111 L20.5070556,2.35742222 C21.9395,3.78864444 21.9395,6.11086667 20.5070556,7.54331111 L14.8897222,13.1594222 C13.4572778,14.5930889 11.1362778,14.5930889 9.70505556,13.1594222"
                  id="Stroke-81"
                />
              </g>
            </g>
            <path
              d="M38.998,8 C38.998,12.42 30.49,16 19.998,16 C9.506,16 0.998,12.42 0.998,8 C0.998,3.584 9.506,0 19.998,0 C30.49,0 38.998,3.584 38.998,8 L38.998,8 Z"
              id="Stroke-4104"
              stroke="#116149"
              strokeWidth="2"
            />
            <path d="M19.998,24 C9.506,24 0.998,20.42 0.998,16" id="Stroke-4105" stroke="#116149" strokeWidth="2" />
            <path
              d="M16.998,32.8984 C7.932,32.2924 0.998,28.9884 0.998,25.0004"
              id="Stroke-4106"
              stroke="#116149"
              strokeWidth="2"
            />
            <path
              d="M17.998,41.957 C8.446,41.535 0.998,38.133 0.998,33.999 L0.998,7.999"
              id="Stroke-4107"
              stroke="#116149"
              strokeWidth="2"
            />
            <path d="M38.998,8 L38.998,17" id="Stroke-4108" stroke="#116149" strokeWidth="2" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EmptyFunction = () => (
  <svg width="60px" height="55px" viewBox="0 0 52 48" version="1.1" className="empty-state-svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="00" transform="translate(-859.000000, -322.000000)" fillRule="nonzero">
        <g id="Group-1304" transform="translate(859.000000, 322.000000)">
          <path
            d="M47.9567304,18.9664 C47.9567304,25.3864568 43.919099,28.6557267 38.8211851,29.8088883 C38.2825098,29.9307381 37.7470484,29.5928343 37.6251986,29.054159 C37.5033488,28.5154837 37.8412527,27.9800223 38.379928,27.8581725 C42.6746691,26.8866907 45.9567304,24.2292059 45.9567304,18.9664 C45.9567304,13.8976323 41.7648439,9.81695198 36.6550672,10.0067543 C36.2553953,10.0216001 35.8853172,9.79688026 35.7141531,9.4354098 C33.5813703,4.93132227 29.0587769,2.00187826 24.0002087,2.00187826 C17.1289724,2.00187826 11.4730482,7.36195591 11.0701274,14.196038 C11.0341915,14.8055593 10.4651784,15.2408623 9.86748631,15.1160754 C5.82979381,14.2730804 2.04368696,17.3456064 2.04368696,21.464487 C2.04368696,24.3812197 3.29884334,26.1555305 5.45502524,27.1504963 C6.76438521,27.7546978 8.11054245,27.957204 9.01567899,27.9504796 C9.56640963,27.9428484 10.0201966,28.3838047 10.0282755,28.9357649 C10.0363583,29.4879905 9.59524334,29.9422101 9.04301774,29.9502929 C8.69299562,29.952932 8.1860562,29.9223024 7.56437349,29.828781 C6.56204121,29.6779974 5.56132819,29.4022155 4.61704433,28.9664776 C1.78279145,27.6586173 0.0436869565,25.200189 0.0436869565,21.464487 C0.0436869565,16.4524684 4.32893948,12.624616 9.17581035,13.0009768 C10.1423095,5.63336499 16.4327046,0.00187826087 24.0002087,0.00187826087 C29.6211246,0.00187826087 34.669168,3.13516472 37.2334874,8.00281486 C43.1814122,8.12755547 47.9567304,12.985824 47.9567304,18.9664 Z"
            id="Stroke-1573"
            fill="#116149"
          />
          <path
            d="M20.6498,18 C21.2020847,18 21.6498,18.4477153 21.6498,19 C21.6498,19.5522847 21.2020847,20 20.6498,20 C19.2795217,20 18.6728298,20.3081027 18.4062234,20.8933239 C18.1573119,21.4397035 18.1278441,22.1059206 18.2197422,23.8732971 C18.252791,24.5088878 18.2660877,24.8277982 18.2710612,25.2096518 C18.3181758,28.8270264 17.0398935,31.0375538 13.2427158,31.9875974 C12.7069458,32.1216457 12.1639508,31.7959858 12.0299026,31.2602158 C11.8958543,30.7244458 12.2215142,30.1814508 12.7572842,30.0474026 C15.5322139,29.3531226 16.3073986,28.0125995 16.2712308,25.2356986 C16.2667007,24.8878803 16.2541756,24.5874781 16.2224404,23.9771507 C16.111632,21.8460927 16.1478938,21.0262739 16.5861903,20.0641801 C17.21542,18.6829733 18.5602781,18 20.6498,18 Z"
            id="Stroke-1378"
            fill="#15CC62"
          />
          <path
            d="M20.6498,42.0175 C21.2020847,42.0175 21.6498,42.4652153 21.6498,43.0175 C21.6498,43.5697847 21.2020847,44.0175 20.6498,44.0175 C18.5602781,44.0175 17.21542,43.3345267 16.5861903,41.9533199 C16.1478938,40.9912261 16.111632,40.1714073 16.2224404,38.0403493 C16.2541756,37.4300219 16.2667007,37.1296197 16.2712308,36.7818014 C16.3073986,34.0049005 15.5322139,32.6643774 12.7572842,31.9700974 C12.2215142,31.8360492 11.8958543,31.2930542 12.0299026,30.7572842 C12.1639508,30.2215142 12.7069458,29.8958543 13.2427158,30.0299026 C17.0398935,30.9799462 18.3181758,33.1904736 18.2710612,36.8078482 C18.2660877,37.1897018 18.252791,37.5086122 18.2197422,38.1442029 C18.1278441,39.9115794 18.1573119,40.5777965 18.4062234,41.1241761 C18.6728298,41.7093973 19.2795217,42.0175 20.6498,42.0175 Z"
            id="Stroke-1379"
            fill="#15CC62"
          />
          <path
            d="M26.8,20 C26.2477153,20 25.8,19.5522847 25.8,19 C25.8,18.4477153 26.2477153,18 26.8,18 C28.8885649,18 30.232876,18.6831079 30.8617076,20.0643594 C31.2996637,21.0263458 31.3358719,21.8460648 31.225067,23.9770092 C31.1933281,24.5873969 31.1807998,24.887846 31.1762645,25.2357116 C31.1400599,28.0126579 31.9148541,29.3532247 34.688036,30.0474326 C35.2237894,30.1815473 35.549382,30.7245826 35.4152674,31.260336 C35.2811527,31.7960894 34.7381174,32.121682 34.202364,31.9875674 C30.4068782,31.0374471 29.1292741,28.8269071 29.1764345,25.2096387 C29.1814134,24.8277486 29.1947132,24.5087963 29.2277653,23.8731535 C29.319668,22.1057274 29.290239,21.4394844 29.0414664,20.8930464 C28.7750865,20.3079332 28.1690943,20 26.8,20 Z"
            id="Stroke-1380"
            fill="#15CC62"
          />
          <path
            d="M26.8,44.0175 C26.2477153,44.0175 25.8,43.5697847 25.8,43.0175 C25.8,42.4652153 26.2477153,42.0175 26.8,42.0175 C28.1690943,42.0175 28.7750865,41.7095668 29.0414664,41.1244536 C29.290239,40.5780156 29.319668,39.9117726 29.2277653,38.1443465 C29.1947132,37.5087037 29.1814134,37.1897514 29.1764345,36.8078613 C29.1292741,33.1905929 30.4068782,30.9800529 34.202364,30.0299326 C34.7381174,29.895818 35.2811527,30.2214106 35.4152674,30.757164 C35.549382,31.2929174 35.2237894,31.8359527 34.688036,31.9700674 C31.9148541,32.6642753 31.1400599,34.0048421 31.1762645,36.7817884 C31.1807998,37.129654 31.1933281,37.4301031 31.225067,38.0404908 C31.3358719,40.1714352 31.2996637,40.9911542 30.8617076,41.9531406 C30.232876,43.3343921 28.8885649,44.0175 26.8,44.0175 Z"
            id="Stroke-1381"
            fill="#15CC62"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EmptyRules = () => (
  <svg width="48px" height="55px" viewBox="0 0 48 55" version="1.1" className="empty-state-svg">
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="00" transform="translate(-612.000000, -242.000000)" fillRule="nonzero">
        <g id="Group-1359" transform="translate(612.000000, 242.000000)">
          <path
            d="M38,9 C38,5.37218759 29.9922189,2 20,2 C10.0077811,2 2,5.37218759 2,9 C2,12.6303366 10.0045511,16 20,16 C29.9954489,16 38,12.6303366 38,9 Z M40,9 C40,14.2080639 30.9923507,18 20,18 C9.00764928,18 0,14.2080639 0,9 C0,3.79464911 9.01098133,0 20,0 C30.9890187,0 40,3.79464911 40,9 Z"
            id="Stroke-4973"
            fill="#116149"
          />
          <path
            d="M20,24 C20.5522847,24 21,24.4477153 21,25 C21,25.5522847 20.5522847,26 20,26 C9.00764928,26 0,22.2080639 0,17 C0,16.4477153 0.44771525,16 1,16 C1.55228475,16 2,16.4477153 2,17 C2,20.6303366 10.0045511,24 20,24 Z"
            id="Stroke-4974"
            fill="#116149"
          />
          <path
            d="M17.0666943,32.9006265 C17.6177494,32.9374608 18.0346077,33.4140393 17.9977735,33.9650943 C17.9609392,34.5161494 17.4843607,34.9330077 16.9333057,34.8961735 C7.29367776,34.2518304 0,30.6892692 0,26.0004 C0,25.4481153 0.44771525,25.0004 1,25.0004 C1.55228475,25.0004 2,25.4481153 2,26.0004 C2,29.2046525 8.37774264,32.3198296 17.0666943,32.9006265 Z"
            id="Stroke-4975"
            fill="#116149"
          />
          <path
            d="M18.0439274,41.9559653 C18.595679,41.9802257 19.0232952,42.4471758 18.9990347,42.9989274 C18.9747743,43.550679 18.5078242,43.9782952 17.9560726,43.9540347 C7.85128665,43.5097288 0,39.8621947 0,34.999 L0,8.999 C0,8.44671525 0.44771525,7.999 1,7.999 C1.55228475,7.999 2,8.44671525 2,8.999 L2,34.999 C2,38.3456292 8.90639919,41.5541895 18.0439274,41.9559653 Z"
            id="Stroke-4976"
            fill="#116149"
          />
          <path
            d="M38,9 C38,8.44771525 38.4477153,8 39,8 C39.5522847,8 40,8.44771525 40,9 L40,18 C40,18.5522847 39.5522847,19 39,19 C38.4477153,19 38,18.5522847 38,18 L38,9 Z"
            id="Stroke-4977"
            fill="#116149"
          />
          <path
            d="M27,48 C26.4477153,48 26,47.5522847 26,47 L26,31 C26,30.4477153 26.4477153,30 27,30 L47,30 C47.5522847,30 48,30.4477153 48,31 L48,47 C48,47.5522847 47.5522847,48 47,48 L27,48 Z M46,46 L46,32 L28,32 L28,46 L46,46 Z"
            id="Stroke-4978"
            fill="#15CC62"
          />
          <path
            d="M38,42 C38,42.5522847 37.5522847,43 37,43 C36.4477153,43 36,42.5522847 36,42 L36,38 C36,37.4477153 36.4477153,37 37,37 C37.5522847,37 38,37.4477153 38,38 L38,42 Z"
            id="Stroke-4979"
            fill="#15CC62"
          />
          <path
            d="M32,31 C32,31.5522847 31.5522847,32 31,32 C30.4477153,32 30,31.5522847 30,31 L30,29 C30,25.1337153 33.1337153,22 37,22 C40.864924,22 44,25.1343543 44,29 L44,31 C44,31.5522847 43.5522847,32 43,32 C42.4477153,32 42,31.5522847 42,31 L42,29 C42,26.2390269 39.7604575,24 37,24 C34.2382847,24 32,26.2382847 32,29 L32,31 Z"
            id="Stroke-4980"
            fill="#15CC62"
          />
          <path
            d="M39,37 C39,38.1059038 38.1046671,39 37,39 C35.8953329,39 35,38.1059038 35,37 C35,35.8957153 35.8957153,35 37,35 C38.1042847,35 39,35.8957153 39,37 Z"
            id="Stroke-4981"
            fill="#15CC62"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EmptyServices = () => (
  <svg width="48px" height="55px" viewBox="0 0 48 55" version="1.1" className="empty-state-svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="00" transform="translate(-981.000000, -226.000000)" fillRule="nonzero">
        <g id="Group-604" transform="translate(982.000000, 227.000000)">
          <path
            d="M38.3650932,17.6776932 C38.7556175,17.2871689 39.3887825,17.2871689 39.7793068,17.6776932 C40.1698311,18.0682175 40.1698311,18.7013825 39.7793068,19.0919068 L31.9993068,26.8719068 C27.3181458,31.5530678 19.3662867,31.2071002 14.3229417,26.1637553 C9.27881178,21.1174632 8.93290665,13.1656909 13.6172586,8.48352791 C15.4888467,6.61281474 17.3482507,4.75397329 19.1104059,2.99213052 C20.100856,2.0018367 20.100856,2.0018367 20.7814024,1.32135275 C21.2857313,0.817055185 21.2857313,0.817055185 21.3950932,0.707693219 C21.7856175,0.317168927 22.4187825,0.317168927 22.8093068,0.707693219 C23.1998311,1.09821751 23.1998311,1.73138249 22.8093068,2.12190678 C22.6999187,2.23129482 22.6999187,2.23129482 22.1955601,2.73562225 C21.5149815,3.4161383 21.5149815,3.4161383 20.5244941,4.40646948 C18.7622743,6.16837671 16.9028033,8.02728526 15.0311415,9.89807201 C11.1570048,13.7703983 11.4479393,20.4584871 15.7373068,24.7496932 C20.0256148,29.0380013 26.7137973,29.3289891 30.5850932,25.4576932 L38.3650932,17.6776932 Z"
            id="Stroke-2002"
            fill="#116149"
          />
          <path
            d="M27.0509068,6.36330678 C26.6603825,6.75383107 26.0272175,6.75383107 25.6366932,6.36330678 C25.2461689,5.97278249 25.2461689,5.33961751 25.6366932,4.94909322 L31.2926932,-0.706906781 C31.6832175,-1.09743107 32.3163825,-1.09743107 32.7069068,-0.706906781 C33.0974311,-0.316382489 33.0974311,0.316782489 32.7069068,0.707306781 L27.0509068,6.36330678 Z"
            id="Stroke-2004"
            fill="#15CC62"
          />
          <path
            d="M35.5371068,14.8477068 C35.1465825,15.2382311 34.5134175,15.2382311 34.1228932,14.8477068 C33.7323689,14.4571825 33.7323689,13.8240175 34.1228932,13.4334932 L39.7788932,7.77749322 C40.1694175,7.38696893 40.8025825,7.38696893 41.1931068,7.77749322 C41.5836311,8.16801751 41.5836311,8.80118249 41.1931068,9.19170678 L35.5371068,14.8477068 Z"
            id="Stroke-2005"
            fill="#15CC62"
          />
          <path
            d="M21.3944932,2.12110678 C21.0039689,1.73058249 21.0039689,1.09741751 21.3944932,0.706893219 C21.7850175,0.316368927 22.4181825,0.316368927 22.8087068,0.706893219 L39.7787068,17.6768932 C40.1692311,18.0674175 40.1692311,18.7005825 39.7787068,19.0911068 C39.3881825,19.4816311 38.7550175,19.4816311 38.3644932,19.0911068 L21.3944932,2.12110678 Z"
            id="Stroke-2003"
            fill="#116149"
          />
          <path
            d="M21.3944307,7.77744427 C21.0039409,7.38688546 21.0039969,6.75372049 21.3945557,6.36323072 C21.7851145,5.97274095 22.4182795,5.97279692 22.8087693,6.36335573 L34.1207693,17.6773557 C34.5112591,18.0679145 34.5112031,18.7010795 34.1206443,19.0915693 C33.7300855,19.4820591 33.0969205,19.4820031 32.7064307,19.0914443 L21.3944307,7.77744427 Z"
            id="Stroke-2006"
            fill="#116149"
          />
          <path
            d="M22.8084932,17.6779068 C22.0270175,16.8964311 20.7621825,16.8964311 19.9801027,17.6785104 C19.1992313,18.4580492 19.1992313,19.7228837 19.9807068,20.5056932 C20.762082,21.2870685 22.0266923,21.2871689 22.8081918,20.5059946 C23.5899687,19.722559 23.5898684,18.457949 22.8084932,17.6779068 Z M24.2233093,21.9193037 C22.6601825,23.4824311 20.1290175,23.4824311 18.5658907,21.9193037 C17.0039687,20.3547163 17.0039687,17.8235508 18.5664932,16.2636932 C20.1290175,14.7011689 22.6601825,14.7011689 24.2221027,16.2630896 C25.7852313,17.8235508 25.7852313,20.3547163 24.2233093,21.9193037 Z"
            id="Stroke-2007"
            fill="#116149"
          />
          <path
            d="M16.6894508,26.6267356 C17.0800621,26.2362984 17.7132271,26.2364395 18.1036644,26.6270508 C18.4941016,27.0176621 18.4939605,27.6508271 18.1033492,28.0412644 L13.6153492,32.5272644 C13.2247994,32.9176401 12.591756,32.9175695 12.2012932,32.5271068 L7.95929322,28.2851068 C7.56883047,27.894644 7.56875993,27.2616006 7.95913565,26.8710508 L12.4451356,22.3830508 C12.8355729,21.9924395 13.4687379,21.9922984 13.8593492,22.3827356 C14.2499605,22.7731729 14.2501016,23.4063379 13.8596644,23.7969492 L10.080456,27.5778424 L12.9085576,30.405944 L16.6894508,26.6267356 Z"
            id="Stroke-2008"
            fill="#116149"
          />
          <path
            d="M10.0800932,28.9920932 C10.4706175,28.6015689 11.1037825,28.6015689 11.4943068,28.9920932 C11.8848311,29.3826175 11.8848311,30.0157825 11.4943068,30.4063068 L2.30230678,39.5983068 C1.13083107,40.7697825 1.13083107,42.6686175 2.30230678,43.8400932 C3.47378249,45.0115689 5.37261751,45.0115689 6.54409322,43.8400932 L12.9080932,37.4760932 C14.4706175,35.9135689 17.0037825,35.9135689 18.5669104,37.4766973 C20.1266299,39.039083 20.1266299,41.569317 18.5663068,43.1323068 L15.2023068,46.4963068 C14.8117825,46.8868311 14.1786175,46.8868311 13.7880932,46.4963068 C13.3975689,46.1057825 13.3975689,45.4726175 13.7880932,45.0820932 L17.1514896,41.7186973 C17.9317701,40.937083 17.9317701,39.671317 17.1520932,38.8903068 C16.3706175,38.1088311 15.1037825,38.1088311 14.3223068,38.8903068 L7.95830678,45.2543068 C6.00578249,47.2068311 2.84061751,47.2068311 0.888093219,45.2543068 C-1.06443107,43.3017825 -1.06443107,40.1366175 0.888093219,38.1840932 L10.0800932,28.9920932 Z"
            id="Stroke-2009"
            fill="#116149"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const RulesIcon = () => (
  <svg width="40px" height="35px" viewBox="0 0 14 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Stitch-Sidebar-(1)-Copy" transform="translate(-12.000000, -315.000000)" fill="#555555">
        <g id="Page-1" transform="translate(12.000000, 315.000000)">
          <path
            d="M8.5,13.5 C8.5,14.328427 7.82843,15 7,15 C6.17157,15 5.5,14.328427 5.5,13.5 C5.5,12.671573 6.17157,12 7,12 C7.82843,12 8.5,12.671573 8.5,13.5 Z"
            id="Fill-1"
          />
          <path
            d="M12,8 L12,5 C12,2.243 9.757,0 7,0 C4.243,0 2,2.243 2,5 L2,8 C0.896,8 0,8.896 0,10 L0,17 C0,18.103001 0.896,19 2,19 L12,19 C13.104,19 14,18.103001 14,17 L14,10 C14,8.896 13.104,8 12,8 Z M4,5 C4,3.346 5.346,2 7,2 C8.654,2 10,3.346 10,5 L10,8 L4,8 L4,5 Z M2,17 L2,10 L12,10 L12.002,17 L2,17 Z"
            id="Fill-3"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const AssetUpload = () => (
  <svg width="59px" height="50px" viewBox="0 0 59 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="02" transform="translate(-743.000000, -288.000000)" fillRule="nonzero">
        <g id="Group-1294" transform="translate(743.000000, 288.000000)">
          <path
            d="M58.2495,22.7925 C58.2495,27.86863 55.9898303,31.4872509 52.2774413,33.7914328 C50.9969689,34.5861883 49.6337434,35.1649179 48.2709614,35.5652582 C47.4473481,35.8072085 46.7958909,35.9377378 46.3985263,35.9895198 L40.247,36 C39.5566441,36 38.997,35.4403559 38.997,34.75 C38.997,34.0596441 39.5566441,33.5 40.247,33.5 L46.1460555,33.5 C46.2157404,33.4888233 46.3195739,33.4703908 46.4538758,33.4434814 C46.7868902,33.3767569 47.1613048,33.2855969 47.5663199,33.1666168 C48.7259988,32.8259415 49.8852342,32.3338117 50.9590587,31.6673172 C53.9732322,29.7964991 55.7495,26.951995 55.7495,22.7925 C55.7495,16.7494283 50.7515678,11.8847464 44.6574906,12.106672 C44.1582949,12.124851 43.6962056,11.8440837 43.482348,11.3926508 C40.9358824,6.01730624 35.5362486,2.52 29.4995,2.52 C21.2976029,2.52 14.5407757,8.92280073 14.0573097,17.0789654 C14.0121575,17.840693 13.3009903,18.384567 12.5540318,18.228616 C7.75075866,17.225782 3.2495,20.8802484 3.2495,25.78 C3.2495,29.2549596 4.74053444,31.3634912 7.30573807,32.5471992 C8.86537254,33.2668894 10.4705162,33.508255 11.5485143,33.5001013 L18.7245,33.5 C19.4148559,33.5 19.9745,34.0596441 19.9745,34.75 C19.9745,35.4403559 19.4148559,36 18.7245,36 L11.5831205,35.9998613 C11.1597465,36.0031133 10.5494212,35.9662983 9.80169445,35.8538626 C8.59682674,35.6726866 7.39386607,35.341198 6.25826193,34.8171758 C2.84534056,33.2422901 0.7495,30.2784779 0.7495,25.78 C0.7495,19.7635265 5.87691758,15.1646137 11.6913781,15.5883169 C12.8766438,6.76358464 20.4263625,0.02 29.4995,0.02 C36.2395589,0.02 42.2960072,3.7726489 45.3812485,9.60315546 C52.5220843,9.77348853 58.2495,15.6095673 58.2495,22.7925 Z"
            id="Stroke-1679"
            fill="#116149"
          />
          <path
            d="M30.75,24.017767 L30.75,48.5 C30.75,49.1903559 30.1903559,49.75 29.5,49.75 C28.8096441,49.75 28.25,49.1903559 28.25,48.5 L28.25,24.017767 L22.8838835,29.3838835 C22.3957281,29.8720388 21.6042719,29.8720388 21.1161165,29.3838835 C20.6279612,28.8957281 20.6279612,28.1042719 21.1161165,27.6161165 L28.6161165,20.1161165 C29.1042719,19.6279612 29.8957281,19.6279612 30.3838835,20.1161165 L37.8838835,27.6161165 C38.3720388,28.1042719 38.3720388,28.8957281 37.8838835,29.3838835 C37.3957281,29.8720388 36.6042719,29.8720388 36.1161165,29.3838835 L30.75,24.017767 Z"
            id="Combined-Shape"
            fill="#15CC62"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const JSLogo = () => (
  <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>icons8-javascript</title>
    <desc>Created with Sketch.</desc>
    <g id="Phase-2:-Data-Access" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Web" transform="translate(-259.000000, -464.000000)" fillRule="nonzero">
        <g id="icons8-javascript" transform="translate(259.000000, 464.000000)">
          <polygon id="Path" fill="#FFD600" points="0 36 0 0 36 0 36 36" />
          <path
            d="M23.538,26.947 C24.23,28.071 24.982,29.148 26.575,29.148 C27.913,29.148 28.615,28.483 28.615,27.563 C28.615,26.462 27.889,26.071 26.417,25.43 L25.61,25.086 C23.281,24.098 21.732,22.86 21.732,20.245 C21.732,17.835 23.577,16.001 26.46,16.001 C28.513,16.001 29.988,16.712 31.052,18.574 L28.538,20.181 C27.985,19.193 27.387,18.804 26.46,18.804 C25.514,18.804 24.915,19.401 24.915,20.181 C24.915,21.145 25.515,21.535 26.9,22.132 L27.707,22.476 C30.452,23.645 32,24.839 32,27.523 C32,30.415 29.716,32 26.65,32 C23.651,32 21.948,30.495 21,28.632 L23.538,26.947 Z M11.952,27.029 C12.458,27.935 13.227,28.632 14.333,28.632 C15.391,28.632 16,28.214 16,26.589 L16,16 L19.333,16 L19.333,27.101 C19.333,30.468 17.38,32 14.528,32 C11.951,32 10.091,30.254 9.333,28.632 L11.952,27.029 Z"
            id="Shape"
            fill="#000001"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const FileIcon = ({ ...rest }) => (
  <svg width="12px" height="15px" viewBox="0 0 12 15" version="1.1" {...passThroughProps(rest)}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="07" transform="translate(-267.000000, -539.000000)" fill="#464C4F">
        <g id="Group-9" transform="translate(267.000000, 539.000000)">
          <polygon id="Fill-1" points="2.66666667 7.33333333 8 7.33333333 8 6 2.66666667 6" />
          <polygon id="Fill-2" points="2.66666667 10 6.66666667 10 6.66666667 8.66666667 2.66666667 8.66666667" />
          <g id="Group-8">
            <path
              d="M10.6673333,13.3333333 L1.33333333,13.3333333 L1.33333333,1.33333333 L8,1.33333333 L8,4 L10.6666667,4 L10.6673333,13.3333333 Z M1.33333333,0 C0.598,0 0,0.598666667 0,1.33333333 L0,13.3333333 C0,14.0693333 0.598,14.6666667 1.33333333,14.6666667 L10.6666667,14.6666667 C11.4026667,14.6666667 12,14.0693333 12,13.3333333 L12,3.05733333 L8.94266667,0 L1.33333333,0 Z"
              id="Fill-3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

FileIcon.displayName = 'FileIcon';

export const FolderIcon = ({ ...rest }) => (
  <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1" {...passThroughProps(rest)}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="07.Hover" transform="translate(-267.000000, -584.000000)" fill="#464C4F">
        <g id="Group-4" transform="translate(267.000000, 584.000000)">
          <path
            d="M10.5,2.25 L6.75,2.25 L5.5125,0.6 C5.23125,0.22425 4.782,0 4.3125,0 L1.5,0 C0.67275,0 0,0.6735 0,1.5 L0,9 C0,9.82725075 0.67275,10.5 1.5,10.5 L10.5,10.5 C11.32725,10.5 12,9.82725075 12,9 L12,3.75 C12,2.9235 11.32725,2.25 10.5,2.25 Z"
            id="Fill-3"
          />
        </g>
      </g>
    </g>
  </svg>
);

FolderIcon.displayName = 'FolderIcon';

export const AnnouncementIcon = (props) => (
  <svg width="24px" height="20px" viewBox="0 0 24 20" version="1.1" className={props.className}>
    <g
      id="Group-1170"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g stroke="#000000">
        <path d="M7.5,4.5 L7.5,13.027 C7.5,15.768 9.049,18.273 11.5,19.5" id="Stroke-353" />
        <path
          d="M23.5,9 C23.5,9.828 22.828,10.5 22,10.5 L21.5,10.5 L21.5,6.5 L22,6.5 C22.828,6.5 23.5,7.172 23.5,8 L23.5,9 L23.5,9 Z"
          id="Stroke-354"
        />
        <path
          d="M4.5,4.5 L3.5,4.5 C1.844,4.5 0.5,5.843 0.5,7.5 L0.5,9.5 C0.5,11.156 1.844,12.5 3.5,12.5 L4.5,12.5 C13.427,12.5 17.09,14.495 21.5,16.5 L21.5,0.5 C17.1,2.5 13.432,4.5 4.5,4.5 L4.5,4.5 Z"
          id="Stroke-355"
        />
      </g>
    </g>
  </svg>
);

AnnouncementIcon.displayName = 'AnnouncementIcon';

export const EmptyFolderIcon = () => {
  const emptyFolderPath = (
    <path d="M1,0.999 C0.446,0.999 0,1.447 0,1.999 C0,2.553 0.446,2.999 1,2.999 C1.55,2.999 2,2.553 2,1.999 C2,1.447 1.55,0.999 1,0.999 Z" />
  );

  return (
    <svg width="48px" height="40px" viewBox="0 0 48 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="07.Error.02" transform="translate(-749.000000, -359.000000)">
          <g id="Group-160" transform="translate(749.000000, 358.000000)">
            <g id="Group-3">
              <mask id="mask-2" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-2" />
              <polygon
                id="Fill-1"
                fill="#16CC62"
                mask="url(#mask-2)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-6" transform="translate(0.000000, 4.000000)">
              <mask id="mask-4" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-5" />
              <polygon
                id="Fill-4"
                fill="#16CC62"
                mask="url(#mask-4)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-9" transform="translate(0.000000, 8.000000)">
              <mask id="mask-6" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-8" />
              <polygon
                id="Fill-7"
                fill="#16CC62"
                mask="url(#mask-6)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-12" transform="translate(0.000000, 12.000000)">
              <mask id="mask-8" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-11" />
              <polygon
                id="Fill-10"
                fill="#16CC62"
                mask="url(#mask-8)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-15" transform="translate(0.000000, 16.000000)">
              <mask id="mask-10" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-14" />
              <polygon
                id="Fill-13"
                fill="#16CC62"
                mask="url(#mask-10)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-18" transform="translate(0.000000, 20.000000)">
              <mask id="mask-12" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-17" />
              <polygon
                id="Fill-16"
                fill="#16CC62"
                mask="url(#mask-12)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-21" transform="translate(0.000000, 24.000000)">
              <mask id="mask-14" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-20" />
              <polygon
                id="Fill-19"
                fill="#16CC62"
                mask="url(#mask-14)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-24" transform="translate(0.000000, 28.000000)">
              <mask id="mask-16" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-23" />
              <polygon
                id="Fill-22"
                fill="#16CC62"
                mask="url(#mask-16)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-27" transform="translate(0.000000, 32.000000)">
              <mask id="mask-18" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-26" />
              <polygon
                id="Fill-25"
                fill="#16CC62"
                mask="url(#mask-18)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-30" transform="translate(2.000000, 36.000000)">
              <mask id="mask-20" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-29" />
              <polygon
                id="Fill-28"
                fill="#16CC62"
                mask="url(#mask-20)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-33" transform="translate(18.000000, 38.000000)">
              <mask id="mask-22" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-32" />
              <polygon
                id="Fill-31"
                fill="#16CC62"
                mask="url(#mask-22)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-36" transform="translate(14.000000, 38.000000)">
              <mask id="mask-24" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-35" />
              <polygon
                id="Fill-34"
                fill="#16CC62"
                mask="url(#mask-24)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-39" transform="translate(22.000000, 38.000000)">
              <mask id="mask-26" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-38" />
              <polygon
                id="Fill-37"
                fill="#16CC62"
                mask="url(#mask-26)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-42" transform="translate(26.000000, 38.000000)">
              <mask id="mask-28" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-41" />
              <polygon
                id="Fill-40"
                fill="#16CC62"
                mask="url(#mask-28)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-45" transform="translate(30.000000, 38.000000)">
              <mask id="mask-30" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-44" />
              <polygon
                id="Fill-43"
                fill="#16CC62"
                mask="url(#mask-30)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-48" transform="translate(34.000000, 38.000000)">
              <mask id="mask-32" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-47" />
              <polygon
                id="Fill-46"
                fill="#16CC62"
                mask="url(#mask-32)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-51" transform="translate(38.000000, 38.000000)">
              <mask id="mask-34" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-50" />
              <polygon
                id="Fill-49"
                fill="#16CC62"
                mask="url(#mask-34)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-54" transform="translate(42.000000, 38.000000)">
              <mask id="mask-36" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-53" />
              <polygon
                id="Fill-52"
                fill="#16CC62"
                mask="url(#mask-36)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-57" transform="translate(46.000000, 36.000000)">
              <mask id="mask-38" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-56" />
              <polygon
                id="Fill-55"
                fill="#16CC62"
                mask="url(#mask-38)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-60" transform="translate(46.000000, 32.000000)">
              <mask id="mask-40" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-59" />
              <polygon
                id="Fill-58"
                fill="#16CC62"
                mask="url(#mask-40)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-63" transform="translate(46.000000, 28.000000)">
              <mask id="mask-42" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-62" />
              <polygon
                id="Fill-61"
                fill="#16CC62"
                mask="url(#mask-42)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-66" transform="translate(46.000000, 24.000000)">
              <mask id="mask-44" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-65" />
              <polygon
                id="Fill-64"
                fill="#16CC62"
                mask="url(#mask-44)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-69" transform="translate(46.000000, 20.000000)">
              <mask id="mask-46" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-68" />
              <polygon
                id="Fill-67"
                fill="#16CC62"
                mask="url(#mask-46)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-72" transform="translate(46.000000, 16.000000)">
              <mask id="mask-48" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-71" />
              <polygon
                id="Fill-70"
                fill="#16CC62"
                mask="url(#mask-48)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-75" transform="translate(46.000000, 12.000000)">
              <mask id="mask-50" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-74" />
              <polygon
                id="Fill-73"
                fill="#16CC62"
                mask="url(#mask-50)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-78" transform="translate(46.000000, 8.000000)">
              <mask id="mask-52" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-77" />
              <polygon
                id="Fill-76"
                fill="#16CC62"
                mask="url(#mask-52)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-81" transform="translate(42.000000, 8.000000)">
              <mask id="mask-54" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-80" />
              <polygon
                id="Fill-79"
                fill="#16CC62"
                mask="url(#mask-54)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-84" transform="translate(38.000000, 8.000000)">
              <mask id="mask-56" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-83" />
              <polygon
                id="Fill-82"
                fill="#16CC62"
                mask="url(#mask-56)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-87" transform="translate(34.000000, 8.000000)">
              <mask id="mask-58" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-86" />
              <polygon
                id="Fill-85"
                fill="#16CC62"
                mask="url(#mask-58)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-90" transform="translate(30.000000, 8.000000)">
              <mask id="mask-60" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-89" />
              <polygon
                id="Fill-88"
                fill="#16CC62"
                mask="url(#mask-60)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-93" transform="translate(26.000000, 8.000000)">
              <mask id="mask-62" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-92" />
              <polygon
                id="Fill-91"
                fill="#16CC62"
                mask="url(#mask-62)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-96" transform="translate(22.000000, 8.000000)">
              <mask id="mask-64" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-95" />
              <polygon
                id="Fill-94"
                fill="#16CC62"
                mask="url(#mask-64)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-99" transform="translate(18.000000, 8.000000)">
              <mask id="mask-66" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-98" />
              <polygon
                id="Fill-97"
                fill="#16CC62"
                mask="url(#mask-66)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-102" transform="translate(14.000000, 8.000000)">
              <mask id="mask-68" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-101" />
              <polygon
                id="Fill-100"
                fill="#16CC62"
                mask="url(#mask-68)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-105" transform="translate(10.000000, 8.000000)">
              <mask id="mask-70" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-104" />
              <polygon
                id="Fill-103"
                fill="#16CC62"
                mask="url(#mask-70)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-108" transform="translate(10.000000, 12.000000)">
              <mask id="mask-72" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-107" />
              <polygon
                id="Fill-106"
                fill="#16CC62"
                mask="url(#mask-72)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-111" transform="translate(10.000000, 16.000000)">
              <mask id="mask-74" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-110" />
              <polygon
                id="Fill-109"
                fill="#16CC62"
                mask="url(#mask-74)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-114" transform="translate(10.000000, 20.000000)">
              <mask id="mask-76" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-113" />
              <polygon
                id="Fill-112"
                fill="#16CC62"
                mask="url(#mask-76)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-117" transform="translate(10.000000, 24.000000)">
              <mask id="mask-78" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-116" />
              <polygon
                id="Fill-115"
                fill="#16CC62"
                mask="url(#mask-78)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-120" transform="translate(10.000000, 28.000000)">
              <mask id="mask-80" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-119" />
              <polygon
                id="Fill-118"
                fill="#16CC62"
                mask="url(#mask-80)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-123" transform="translate(10.000000, 32.000000)">
              <mask id="mask-82" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-122" />
              <polygon
                id="Fill-121"
                fill="#16CC62"
                mask="url(#mask-82)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-126" transform="translate(8.000000, 36.000000)">
              <mask id="mask-84" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-125" />
              <polygon
                id="Fill-124"
                fill="#16CC62"
                mask="url(#mask-84)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-129" transform="translate(4.000000, 0.000000)">
              <mask id="mask-86" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-128" />
              <polygon
                id="Fill-127"
                fill="#16CC62"
                mask="url(#mask-86)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-132" transform="translate(8.000000, 0.000000)">
              <mask id="mask-88" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-131" />
              <polygon
                id="Fill-130"
                fill="#16CC62"
                mask="url(#mask-88)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-135" transform="translate(12.000000, 0.000000)">
              <mask id="mask-90" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-134" />
              <polygon
                id="Fill-133"
                fill="#16CC62"
                mask="url(#mask-90)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-138" transform="translate(16.000000, 0.000000)">
              <mask id="mask-92" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-137" />
              <polygon
                id="Fill-136"
                fill="#16CC62"
                mask="url(#mask-92)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-141" transform="translate(16.000000, 4.000000)">
              <mask id="mask-94" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-140" />
              <polygon
                id="Fill-139"
                fill="#16CC62"
                mask="url(#mask-94)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-144" transform="translate(20.000000, 4.000000)">
              <mask id="mask-96" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-143" />
              <polygon
                id="Fill-142"
                fill="#16CC62"
                mask="url(#mask-96)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-147" transform="translate(24.000000, 4.000000)">
              <mask id="mask-98" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-146" />
              <polygon
                id="Fill-145"
                fill="#16CC62"
                mask="url(#mask-98)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-150" transform="translate(28.000000, 4.000000)">
              <mask id="mask-100" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-149" />
              <polygon
                id="Fill-148"
                fill="#16CC62"
                mask="url(#mask-100)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-153" transform="translate(32.000000, 4.000000)">
              <mask id="mask-102" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-152" />
              <polygon
                id="Fill-151"
                fill="#16CC62"
                mask="url(#mask-102)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-156" transform="translate(36.000000, 4.000000)">
              <mask id="mask-104" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-155" />
              <polygon
                id="Fill-154"
                fill="#16CC62"
                mask="url(#mask-104)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
            <g id="Group-159" transform="translate(40.000000, 4.000000)">
              <mask id="mask-106" fill="white">
                {emptyFolderPath}
              </mask>
              <g id="Clip-158" />
              <polygon
                id="Fill-157"
                fill="#16CC62"
                mask="url(#mask-106)"
                points="-10 12.999 12 12.999 12 -9.001 -10 -9.001"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const svgPropTypes = {
  className: PropTypes.string,
};

export const SchemaNoDataIcon = () => (
  <svg width="42px" height="34px" viewBox="0 0 42 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Part-1:-Realm-Schema" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Realm-Mobile---No-onboarding-V2" transform="translate(-815.000000, -460.000000)">
        <g id="fontawesome-free-5.5.0/Solid/code" transform="translate(815.000000, 460.000000)">
          <g id="code">
            <path
              d="M18.311215,33.4442308 L14.3205607,32.2869231 C13.9018692,32.1692308 13.6663551,31.7311538 13.7841121,31.3126923 L22.7140187,0.568846154 C22.8317757,0.150384615 23.2700935,-0.085 23.688785,0.0326923077 L27.6794393,1.19 C28.0981308,1.30769231 28.3336449,1.74576923 28.2158879,2.16423077 L19.2859813,32.9080769 C19.1616822,33.3265385 18.7299065,33.5684615 18.311215,33.4442308 L18.311215,33.4442308 Z"
              id="Path"
              fill="#16CC62"
            />
            <path
              d="M1.16602333,16.7352507 L10.2710802,8.20987042 L12.8176389,10.9247073 L6.20514573,16.7384615 L12.8176389,22.5522158 L10.2711334,25.2669959 L1.16602333,16.7352507 Z"
              id="Path"
              stroke="#116C36"
              strokeWidth="2"
              fill="#116C36"
            />
            <path
              d="M29.1823611,22.5522158 L35.7943189,16.7389323 L29.1822655,10.9182706 L31.7288134,8.20344546 L40.8341012,16.7416725 L31.7321308,25.2704758 L29.1823611,22.5522158 Z"
              id="Path"
              stroke="#116C36"
              strokeWidth="2"
              fill="#116C36"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const SchemaDatabaseIcon = () => (
  <svg width="30px" height="34px" viewBox="0 0 30 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Part-1:-Realm-Schema" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Realm-Mobile---No-onboarding-V2"
        transform="translate(-503.000000, -461.000000)"
        fill="#116C36"
        stroke="#116C36"
        strokeWidth="2"
      >
        <g id="fontawesome-free-5.5.0/Solid/database" transform="translate(503.000000, 461.000000)">
          <g id="database">
            <path
              d="M14.5185185,1 C18.4008312,1 21.9188427,1.51263951 24.4660581,2.35169698 C25.671432,2.74874938 26.6500674,3.21151967 27.3139242,3.73855733 C27.7193628,4.06043607 28.037037,4.38929048 28.037037,4.78242692 L28.037037,7.77141923 C28.037037,8.16455567 27.7193628,8.49341008 27.3139242,8.81528882 C26.6500674,9.34232648 25.671432,9.80509677 24.4660581,10.2021492 C21.9188427,11.0412066 18.4008312,11.5538462 14.5185185,11.5538462 C10.6362058,11.5538462 7.11819433,11.0412066 4.57097897,10.2021492 C3.36560505,9.80509677 2.38696964,9.34232648 1.72311279,8.81528882 C1.31767419,8.49341008 1,8.16455567 1,7.77141923 L1,4.78242692 C1,4.38929048 1.31767419,4.06043607 1.72311279,3.73855733 C2.38696964,3.21151967 3.36560505,2.74874938 4.57097897,2.35169698 C7.11819433,1.51263951 10.6362058,1 14.5185185,1 Z"
              id="Path"
            />
            <path
              d="M28.037037,13.2360542 L28.037037,18.2329577 C28.037037,18.6260941 27.7193628,18.9549485 27.3139242,19.2768273 C26.6500674,19.8038649 25.671432,20.2666352 24.4660581,20.6636876 C21.9188427,21.5027451 18.4008312,22.0153846 14.5185185,22.0153846 C10.6362058,22.0153846 7.11819433,21.5027451 4.57097897,20.6636876 C3.36560505,20.2666352 2.38696964,19.8038649 1.72311279,19.2768273 C1.31767419,18.9549485 1,18.6260941 1,18.2329577 L1,13.2360632 C4.38791799,14.8776008 9.45106326,15.6835538 14.5185185,15.6835538 C19.5859844,15.6835538 24.6490927,14.8775995 28.037037,13.2360542 Z"
              id="Path"
            />
            <path
              d="M28.037037,23.6975926 L28.037037,28.6944962 C28.037037,29.0876326 27.7193628,29.416487 27.3139242,29.7383657 C26.6500674,30.2654034 25.671432,30.7281737 24.4660581,31.1252261 C21.9188427,31.9642836 18.4008312,32.4769231 14.5185185,32.4769231 C10.6362058,32.4769231 7.11819433,31.9642836 4.57097897,31.1252261 C3.36560505,30.7281737 2.38696964,30.2654034 1.72311279,29.7383657 C1.31767419,29.416487 1,29.0876326 1,28.6944962 L1,23.6976017 C4.38791799,25.3391393 9.45106326,26.1450923 14.5185185,26.1450923 C19.5859844,26.1450923 24.6490927,25.3391379 28.037037,23.6975926 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

AnnouncementIcon.propTypes = svgPropTypes;
Code.propTypes = svgPropTypes;
Twilio.propTypes = svgPropTypes;
Github.propTypes = svgPropTypes;
AWS.propTypes = svgPropTypes;
MongoDB.propTypes = svgPropTypes;
PushNotifications.propTypes = svgPropTypes;
